(function ($) {
  $('select#event-state').select2({
    width: 'resolve',
    placeholder: "Régions",
    allowClear: true,
    language: 'fr'

  }).on('select2:select',function (){
    submitForm() ;
  });
  $('select#event-type').select2({
    width: 'resolve',
    placeholder: "Tout les événements",
    allowClear: true,
    language: 'fr',
  }).on('select2:select',function (){
    submitForm();
  });

  $('select#event-date').select2({
    width: 'resolve',
    placeholder: "Date",
    allowClear: true,
    language: 'fr',
  }).on('select2:select',function (){
  });

  var selected = $('select#event-date').val();

  $(window).load( function () {
    if (selected === 'range') {
      $('#form-search-event-date-range').show();
    }
  });

  $('select#event-date').on('change', function() {
    var data = $('select#event-date option:selected').text();
    if (data === 'Par période') {
      $('#form-search-event-date-range').show();
    } else {
      $('#form-search-event-date-range').hide();
      submitForm();
    }
  });

  $('input[name="event-date"]').on('change', (e) => {
    if ($(e.currentTarget).is(':checked')) {
      if ($(e.currentTarget).attr('value') === 'range') {
        $('#form-search-event-date-range').show();
      } else {
        $('#form-search-event-date-range').hide();
      }
    }
  }).trigger('change');

  $('.event-date-range-inputs input').on('click', () => {
    $('#event-date-range').prop('checked', true);
  });

  $('#clearForm').on('click', () => {
    $('select#event-date').empty();
    $('select#event-type').empty();
    $('select#event-state').empty();
    submitForm() ;
  });

  $('#event-date-to').on('change', function () {
    submitForm() ;
  });
  //
  // $('#event-date-range').on('click', function (event) {
  //   $('.event-date-range-inputs').show();
  // });
  //
  // $('[name="event-date"]').not('#event-date-range').on('click', function (event) {
  //   $('.event-date-range-inputs').hide();
  // });
  function submitForm() {
    var form = document.getElementById('submit-search');
    form.click();
  }

})(jQuery);
